import React, { Component } from "react";
import { assertNodeAcceptsNewBooking } from "../../../utils/nodeBookingAvailability";
import { Button, Dropdown, Modal } from "react-bootstrap";
import {
  setEvent,
  eventTmp,
  paymentPrivilages,
  colorList,
  statusList,
  typeList,
  PatientTextInfo,
} from "./BookingUtils";
import { PatientDropDownForm } from "./BookingUtils";
import { db } from "../../../firebase";
import * as XLSX from "xlsx";
import {
  query,
  getDocs,
  getDoc,
  collection,
  collectionGroup,
  where,
  doc,
  setDoc,
  limit,
  deleteDoc,
} from "firebase/firestore";
import Toast from "../toast/SetToast";
import { notifyTopRight, notifyError, notifyWarning } from "../toast/SetToast";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import swal from "sweetalert";
import BookingTable from "./BookingTable";
import {
  BOOKING_ADDITIONAL_EQUIPMENT_OPTIONS,
  BookingAdditionalEquipmentField,
  readBookingAdditionalEquipment,
} from "./BookingAdditionalEquipment";
import { resolveBookingImportCustomer } from "./BookingImportCustomerUtils";
import PageTitle from "../../layouts/PageTitle";
import { AuthContext } from "../../../context/AuthContext";
import {
  filterCustomersForStaffNode,
  filterRecordsByStaffCustomerAccess,
} from "../../../utils/staffCustomerAccess";
import {
  canEditBookingSale,
  filterBookingsForSaleAccess,
  getBookingSaleOptions,
  getBookingSaleSaveValue,
  isBookingSaleScopedUser,
} from "./BookingSaleAccess";

const BOOKING_IMPORT_TOAST_OPTIONS = {
  autoClose: 10000,
  style: { whiteSpace: "pre-line" },
};

class BookingList extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      textSearch: "",
      sortBy: "firstname",
      typeBy: "ทั้งหมด",
      statusBy: "ทั้งหมด",
      reportBy: "all",
      techBy: "กรุณาเลือก",
      nodeBy: "",
      isAddEventModal: false,
      isDatetime: false,
      isNewPatient: false,
      dateTmp: new Date().toISOString().slice(0, 10),
      timeTmp: "",
      items: [],
      totalValue: 0,
      itemList: [],
      doctorList: [],
      saleList: [],
      technicianList: [],
      techrecordList: [],
      nodeList: [],
      nodeIdDocs: [],
      customerList: [],
      customerAllList: [],
      customerMetaAllList: [],
      bookingList: [],
      currentAdmin: null,
      allowedNodeDocs: [],
      fileUrl: null,
      batchImportFile: null,
      batchImportFileName: "",
      isSubmittingBatchImport: false,
      isMigratingCustomerBookings: false,
    };
  }

  dateRef = React.createRef();
  titleRef = React.createRef();
  idRef = React.createRef();
  orderRef = React.createRef();
  nodeRef = React.createRef();
  customerRef = React.createRef();
  hnRef = React.createRef();
  typeRef = React.createRef();
  additionalEquipmentRefs = BOOKING_ADDITIONAL_EQUIPMENT_OPTIONS.reduce(
    (refs, option) => ({ ...refs, [option]: React.createRef() }),
    {},
  );
  statusRef = React.createRef();
  saleRef = React.createRef();
  colorRef = React.createRef();
  firstnameRef = React.createRef();
  lastnameRef = React.createRef();
  nationalIdRef = React.createRef();
  healthInsuranceRef = React.createRef();
  phoneRef = React.createRef();
  noteRef = React.createRef();
  itemsRef = React.createRef([]);
  techRef = React.createRef([]);
  docRef = React.createRef([]);
  referDocRef = React.createRef([]);
  techRecordRef = React.createRef([]);
  fileInputRef = React.createRef(null);
  ahiRef = React.createRef();
  hospitalNumberRef = React.createRef();
  genderRef = React.createRef();
  techConsultRef = React.createRef();
  postDoctorRef = React.createRef();

  getBookingSaleOptions = (currentSale = "") =>
    getBookingSaleOptions({
      currentUser: this.context && this.context.currentUser,
      saleNames: this.state.saleList,
      currentSale,
    });

  getSelectedBookingSale = (currentSale = "") => {
    const currentUser = this.context && this.context.currentUser;
    const options = this.getBookingSaleOptions(currentSale);
    return isBookingSaleScopedUser(currentUser)
      ? options[0] || ""
      : currentSale || "";
  };

  getBookingSaleValueForSave = (currentSale = "") =>
    getBookingSaleSaveValue({
      currentUser: this.context && this.context.currentUser,
      saleNames: this.state.saleList,
      selectedSale:
        this.saleRef && this.saleRef.current
          ? this.saleRef.current.value
          : currentSale,
      currentSale,
    });

  renderBookingSaleField = (currentSale = "") => (
    <PatientDropDownForm
      title="Sale"
      id="sale"
      refvalue={this.saleRef}
      selected={this.getSelectedBookingSale(currentSale)}
      options={this.getBookingSaleOptions(currentSale)}
      disabled={
        !canEditBookingSale(this.context && this.context.currentUser)
      }
    />
  );

  sortTitle = ["HN", "Name", "Sleep Study", "Activity Date"];
  sortKey = ["hn", "firstname", "order", "start"];

  onClick = (e) => {
    e.preventDefault();
    console.log("onclick..");
  };

  fetchInitialData = async () => {
    try {
      const [nodesDocs, itemsDocs, techDocs, docDocs, salesDocs] =
        await Promise.all([
        getDocs(collection(db, "nodes")),
        getDocs(collection(db, "items")),
        getDocs(collection(db, "sleeptechnicians")),
        getDocs(collection(db, "doctors")),
        getDocs(collection(db, "sales")),
        ]);

      let allCustomers = [];
      let allCustomerMeta = [];
      let bookingEvent = [];
      let allnodeIdDocs = [];
      let allNodes = [];
      let allowedNodeDocs = nodesDocs.docs.map((nodeDoc) => ({
        id: nodeDoc.id,
        ...nodeDoc.data(),
      }));
      let currentAdminData = null;
      const currentUserRoles = Array.isArray(
        this.context.currentUser.roles,
      )
        ? this.context.currentUser.roles
        : [];

      if (
        !isBookingSaleScopedUser(this.context.currentUser) &&
        currentUserRoles.some((role) =>
          [
            "super_admin",
            "accountant",
            "sleep_physician",
            "sleep_technician",
          ].includes(role),
        )
      ) {
        this.setState({ nodeBy: "ทั้งหมด" });
        allNodes = nodesDocs.docs.map((docItem) => docItem.data().nodename);
        allnodeIdDocs = nodesDocs.docs.map((docItem) => docItem.id);
      } else {
        const currentAdminTemp = await getDoc(
          doc(db, "admins", this.context.currentUser.displayName),
        );
        currentAdminData = currentAdminTemp.exists()
          ? currentAdminTemp.data()
          : {};
        this.setState({ currentAdmin: currentAdminData });
        let nodeCode = currentAdminData.node || [];

        if (!Array.isArray(nodeCode)) {
          nodeCode = nodeCode ? [nodeCode] : [];
        }

        allowedNodeDocs = allowedNodeDocs.filter((nodeData) =>
          nodeCode.includes(nodeData.nodecode),
        );

        allnodeIdDocs = allowedNodeDocs.map((nodeData) => nodeData.id);
        allNodes = allowedNodeDocs.map((nodeData) => nodeData.nodename);

        this.setState({
          nodeBy: isBookingSaleScopedUser(this.context.currentUser)
            ? "ทั้งหมด"
            : allNodes[0] || "",
        });
      }

      const normalizeBookingForList = (bookingData) => {
        const cloned = { ...bookingData };

        if (cloned.start && typeof cloned.start.toDate === "function") {
          const dateStart = new Date(cloned.start.toDate());
          dateStart.setHours(dateStart.getHours() + 7);
          cloned.start = dateStart.toISOString().slice(0, 10);
        } else if (cloned.start instanceof Date) {
          const dateStart = new Date(cloned.start);
          dateStart.setHours(dateStart.getHours() + 7);
          cloned.start = dateStart.toISOString().slice(0, 10);
        } else if (typeof cloned.start === "string") {
          cloned.start = cloned.start.slice(0, 10);
        } else {
          cloned.start = "";
        }

        return cloned;
      };

      const makeDisplayKey = (bookingData) => {
        const ep = bookingData.extendedProps || {};
        return (
          ep.uuid ||
          [
            this.normalizeText(ep.node),
            this.normalizeText(ep.order),
            this.normalizeText(ep.hn),
            this.normalizeText(bookingData.start),
          ].join("|")
        );
      };

      const fetchNodeData = allnodeIdDocs.map(async (nodeId) => {
        const nodeData = allowedNodeDocs.find((node) => node.id === nodeId);
        const customerDocs = await getDocs(
          collection(db, "nodes", nodeId, "customers"),
        );
        const allowedCustomerDocs = filterCustomersForStaffNode({
          customers: customerDocs.docs,
          currentUser: this.context.currentUser,
          adminData: currentAdminData,
          nodeCode: nodeData ? nodeData.nodecode : "",
          getCustomerId: (customerDoc) => customerDoc.id,
        });

        const customersData = allowedCustomerDocs.map(
          (customer) => customer.id,
        );
        const customersMeta = allowedCustomerDocs.map((customer) => {
          const data = customer.data() || {};
          return {
            id: customer.id,
            CustomerNameEN: this.normalizeText(data.CustomerNameEN || ""),
            CustomerNameTH: this.normalizeText(data.CustomerNameTH || ""),
            isOnlyNodeCustomer: customerDocs.docs.length === 1,
          };
        });

        const nestedBookingPromises = allowedCustomerDocs.map((customerDoc) =>
          getDocs(
            collection(
              db,
              "nodes",
              nodeId,
              "customers",
              customerDoc.id,
              "bookings",
            ),
          ),
        );

        const rootBookingPromise = getDocs(
          collection(db, "nodes", nodeId, "bookings"),
        );

        const [nestedBookingSnaps, rootBookingSnap] = await Promise.all([
          Promise.all(nestedBookingPromises),
          rootBookingPromise,
        ]);

        const mergedMap = {};

        nestedBookingSnaps.forEach((snap, customerIndex) => {
          const parentCustomer = allowedCustomerDocs[customerIndex];
          snap.docs.forEach((bookingDoc) => {
            const bookingData = normalizeBookingForList(bookingDoc.data());
            const extendedProps = bookingData.extendedProps || {};
            bookingData.extendedProps = {
              ...extendedProps,
              customer:
                extendedProps.customer ||
                (parentCustomer ? parentCustomer.id : ""),
            };
            const key = makeDisplayKey(bookingData);
            if (!mergedMap[key]) {
              mergedMap[key] = bookingData;
            }
          });
        });

        rootBookingSnap.docs.forEach((bookingDoc) => {
          const bookingData = normalizeBookingForList(bookingDoc.data());
          const key = makeDisplayKey(bookingData);
          if (!mergedMap[key]) {
            mergedMap[key] = bookingData;
          }
        });

        return {
          customersData,
          customersMeta,
          nodeBookings: Object.values(mergedMap),
        };
      });

      const nodeData = await Promise.all(fetchNodeData);

      nodeData.forEach(({ customersData, customersMeta, nodeBookings }) => {
        allCustomers.push(customersData);
        allCustomerMeta.push(customersMeta || []);
        bookingEvent = [...bookingEvent, ...nodeBookings];
      });
      bookingEvent = filterRecordsByStaffCustomerAccess({
        records: bookingEvent,
        currentUser: this.context.currentUser,
        adminData: currentAdminData,
        nodes: allowedNodeDocs,
        getNodeValue: (booking) =>
          booking.extendedProps && booking.extendedProps.node,
        getCustomerValue: (booking) =>
          booking.extendedProps && booking.extendedProps.customer,
      });
      bookingEvent = filterBookingsForSaleAccess({
        records: bookingEvent,
        currentUser: this.context.currentUser,
        assignedNodes: allowedNodeDocs,
      });

      const allItems = itemsDocs.docs.map((docItem) => ({
        ...docItem.data(),
        itemcode: docItem.id,
      }));
      const allTechs = [
        "กรุณาเลือก",
        ...techDocs.docs.map((docItem) => docItem.data().name),
      ];
      const allTechsRecord = [
        "กรุณาเลือก",
        ...techDocs.docs.map((docItem) => docItem.data().name),
      ];
      const allDocs = [
        "กรุณาเลือก",
        ...docDocs.docs.map((docItem) => docItem.data().name),
      ];
      const allSales = salesDocs.docs
        .map((saleDoc) => saleDoc.data().name || "")
        .filter(Boolean)
        .sort((left, right) => left.localeCompare(right, "en"));

      this.setState({
        bookingList: bookingEvent,
        nodeList: allNodes,
        customerAllList: allCustomers,
        customerMetaAllList: allCustomerMeta,
        customerList: allCustomers[0] || [],
        doctorList: allDocs,
        saleList: allSales,
        technicianList: allTechs,
        techrecordList: allTechsRecord,
        itemList: allItems,
        nodeIdDocs: allnodeIdDocs,
        allowedNodeDocs,
      });
    } catch (error) {
      console.log("Error fetching data: ", error);
    }
  };

  async componentDidMount() {
    setTimeout(() => {
      this.fetchInitialData();
    }, 10);
  }

  normalizeText = (value) => {
    return String(value || "")
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  };

  normalizeNameKey = (firstname, lastname) => {
    return `${this.normalizeText(firstname)}|${this.normalizeText(lastname)}`.toLowerCase();
  };

  normalizeCustomerMatchKey = (value) => {
    return this.normalizeText(value)
      .toLowerCase()
      .replace(/[.,]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  };

  splitThaiFullName = (fullName) => {
    const clean = this.normalizeText(fullName);
    if (!clean) {
      return { firstname: "", lastname: "" };
    }

    const parts = clean.split(" ");
    if (parts.length === 1) {
      return { firstname: parts[0], lastname: "" };
    }

    return {
      firstname: parts[0],
      lastname: parts.slice(1).join(" "),
    };
  };

  getCheckedValue = (value) => {
    return this.normalizeText(value) === "✅";
  };

  getMappedTypeFromRow = (row) => {
    if (this.getCheckedValue(row["ชนิดการตรวจการนอนหลับ|FN"])) {
      return "Full Night Sleep Study";
    }
    if (this.getCheckedValue(row["ชนิดการตรวจการนอนหลับ|SN"])) {
      return "Split Night Sleep Study";
    }
    if (this.getCheckedValue(row["ชนิดการตรวจการนอนหลับ|HN"])) {
      return "Home Full Night Sleep Study";
    }
    if (this.getCheckedValue(row["ชนิดการตรวจการนอนหลับ|CT"])) {
      return "CPAP Titration";
    }
    if (this.getCheckedValue(row["ชนิดการตรวจการนอนหลับ|OPO"])) {
      return "Overnight Pulse Oximetry Study";
    }
    return "";
  };

  getMappedAHIFromRow = (row) => {
    if (this.getCheckedValue(row["AHI (ครั้ง/ชั่วโมง)|น้อยกว่า 5"])) {
      return "น้อยกว่า 5";
    }
    if (this.getCheckedValue(row["AHI (ครั้ง/ชั่วโมง)|5 ถึง 15"])) {
      return "5 ถึง 15";
    }
    if (this.getCheckedValue(row["AHI (ครั้ง/ชั่วโมง)|มากกว่า 15"])) {
      return "มากกว่า 15";
    }
    return "";
  };

  getHealthInsuranceFromRow = (row) => {
    return this.getCheckedValue(row["เงินสด"]) ? "ชำระเงินเอง" : "ประกันสังคม";
  };

  getStatusColor = (status) => {
    const idx = statusList.findIndex((s) => s === status);
    return idx !== -1 ? colorList[idx] : "#005DEA";
  };

  buildNote = (remark, packageDetail) => {
    const parts = [
      this.normalizeText(remark),
      this.normalizeText(packageDetail),
    ].filter(Boolean);

    return parts.join(" | ");
  };

  createRandomId = () => {
    return `batch_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  };

  formatExcelDateToString = (value) => {
    if (value === null || value === undefined || value === "") return "";

    if (typeof value === "string") {
      const clean = this.normalizeText(value);
      if (!clean) return "";
      return clean;
    }

    if (value instanceof Date && !isNaN(value.getTime())) {
      return value.toISOString().slice(0, 10);
    }

    if (typeof value === "number") {
      const parsed = XLSX.SSF.parse_date_code(value);
      if (parsed) {
        const yyyy = parsed.y;
        const mm = String(parsed.m).padStart(2, "0");
        const dd = String(parsed.d).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      }
    }

    return this.normalizeText(value);
  };

  getJSDateFromExcelValue = (value) => {
    if (value === null || value === undefined || value === "") return null;

    if (value instanceof Date && !isNaN(value.getTime())) {
      return value;
    }

    if (typeof value === "number") {
      const parsed = XLSX.SSF.parse_date_code(value);
      if (parsed) {
        return new Date(parsed.y, parsed.m - 1, parsed.d);
      }
    }

    const asString = this.formatExcelDateToString(value);
    const d = new Date(asString);
    return isNaN(d.getTime()) ? null : d;
  };

  findHeaderKey = (headers, targets) => {
    const normalizedHeaders = headers.map((h) =>
      this.normalizeText(h).toLowerCase(),
    );

    for (let i = 0; i < normalizedHeaders.length; i++) {
      for (const target of targets) {
        const t = this.normalizeText(target).toLowerCase();
        if (normalizedHeaders[i] === t) {
          return headers[i];
        }
      }
    }

    for (let i = 0; i < normalizedHeaders.length; i++) {
      for (const target of targets) {
        const t = this.normalizeText(target).toLowerCase();
        if (
          normalizedHeaders[i].includes(t) ||
          t.includes(normalizedHeaders[i])
        ) {
          return headers[i];
        }
      }
    }

    return "";
  };

  buildHeadersFromRows = (sheet, groupRowIndex, headerRowIndex) => {
    const ref = sheet["!ref"];
    if (!ref) return [];

    const range = XLSX.utils.decode_range(ref);
    const headers = [];
    let lastGroupHeader = "";

    for (let c = range.s.c; c <= range.e.c; c++) {
      const groupCell = sheet[XLSX.utils.encode_cell({ r: groupRowIndex, c })];
      const headerCell =
        sheet[XLSX.utils.encode_cell({ r: headerRowIndex, c })];

      const groupHeader = this.normalizeText(groupCell ? groupCell.v : "");
      const header = this.normalizeText(headerCell ? headerCell.v : "");

      if (groupHeader) {
        lastGroupHeader = groupHeader;
      }

      if (groupHeader && !header) {
        headers.push(groupHeader);
        continue;
      }

      if (groupHeader && header) {
        headers.push(`${groupHeader}|${header}`);
        continue;
      }

      if (!groupHeader && header && lastGroupHeader) {
        headers.push(`${lastGroupHeader}|${header}`);
        continue;
      }

      headers.push(header);
    }

    return headers;
  };

  detectSheetLayout = (sheet) => {
    const headersA = this.buildHeadersFromRows(sheet, 1, 2);
    const scoreA =
      (this.findHeaderKey(headersA, ["Sleep Study No.", "Sleep Study No"])
        ? 1
        : 0) +
      (this.findHeaderKey(headersA, ["ชื่อ - นามสกุล", "ชื่อ-นามสกุล"])
        ? 1
        : 0) +
      (this.findHeaderKey(headersA, ["วันที่ตรวจการนอนหลับ"]) ? 1 : 0);

    const ref = sheet["!ref"];
    if (!ref) {
      return { headers: [], dataStartRow: 3 };
    }

    const range = XLSX.utils.decode_range(ref);
    const pureRow3Headers = [];
    for (let c = range.s.c; c <= range.e.c; c++) {
      const headerCell = sheet[XLSX.utils.encode_cell({ r: 2, c })];
      pureRow3Headers.push(this.normalizeText(headerCell ? headerCell.v : ""));
    }

    const scoreB =
      (this.findHeaderKey(pureRow3Headers, [
        "Sleep Study No.",
        "Sleep Study No",
      ])
        ? 1
        : 0) +
      (this.findHeaderKey(pureRow3Headers, ["ชื่อ - นามสกุล", "ชื่อ-นามสกุล"])
        ? 1
        : 0) +
      (this.findHeaderKey(pureRow3Headers, ["วันที่ตรวจการนอนหลับ"]) ? 1 : 0);

    if (scoreB >= scoreA) {
      return {
        headers: pureRow3Headers,
        dataStartRow: 3,
      };
    }

    return {
      headers: headersA,
      dataStartRow: 3,
    };
  };

  convertSheetToObjects = (sheet) => {
    const ref = sheet["!ref"];
    if (!ref) return [];

    const range = XLSX.utils.decode_range(ref);
    const layout = this.detectSheetLayout(sheet);
    const headers = layout.headers || [];
    const dataStartRow =
      layout && layout.dataStartRow !== undefined ? layout.dataStartRow : 3;

    if (!headers.length) return [];

    const sleepStudyKey = this.findHeaderKey(headers, [
      "Sleep Study No.",
      "Sleep Study No",
    ]);
    const fullNameKey = this.findHeaderKey(headers, [
      "ชื่อ - นามสกุล",
      "ชื่อ-นามสกุล",
    ]);
    const sleepDateKey = this.findHeaderKey(headers, ["วันที่ตรวจการนอนหลับ"]);

    if (!sleepStudyKey && !fullNameKey && !sleepDateKey) {
      return [];
    }

    const rows = [];

    for (let r = dataStartRow; r <= range.e.r; r++) {
      const rowObj = {};

      for (let c = range.s.c; c <= range.e.c; c++) {
        const header = headers[c - range.s.c];
        if (!header) continue;

        const cell = sheet[XLSX.utils.encode_cell({ r, c })];
        rowObj[header] = cell ? cell.v : "";
      }

      rowObj.__rowNum = r + 1;

      const hasUsefulData =
        this.normalizeText(rowObj[sleepStudyKey]) !== "" ||
        this.normalizeText(rowObj[fullNameKey]) !== "" ||
        this.normalizeText(rowObj[sleepDateKey]) !== "";

      if (hasUsefulData) {
        rows.push(rowObj);
      }
    }

    return rows;
  };

  createNodeCustomerNameEnMap = () => {
    const result = {};
    this.state.nodeList.forEach((nodeName, index) => {
      result[nodeName] = this.state.customerMetaAllList[index] || [];
    });
    return result;
  };

  createNodeNameToIdMap = () => {
    const result = {};
    this.state.nodeList.forEach((nodeName, index) => {
      result[nodeName] = this.state.nodeIdDocs[index];
    });
    return result;
  };

  findNodeNameByOrderAndCustomer = (order, customer, nodeCustomerMap) =>
    resolveBookingImportCustomer(
      order,
      customer,
      this.state.allowedNodeDocs,
      nodeCustomerMap,
    );

  loadPatientsMap = async () => {
    const patientSnap = await getDocs(collection(db, "patients"));
    const patientMap = {};

    const visiblePatients = filterRecordsByStaffCustomerAccess({
      records: patientSnap.docs.map((patientDoc) => patientDoc.data()),
      currentUser: this.context.currentUser,
      adminData: this.state.currentAdmin,
      nodes: this.state.allowedNodeDocs,
      getNodeValue: (patient) => patient.nodeRef,
      getCustomerValue: (patient) => patient.refCustomer,
    });

    visiblePatients.forEach((data = {}) => {
      const key = this.normalizeNameKey(data.firstnameTh, data.lastnameTh);
      if (key && !patientMap[key]) {
        patientMap[key] = {
          hn: data.hn || "",
          refHn: data.refHn || "",
          gender: data.gender || "",
          raw: data,
        };
      }
    });

    return patientMap;
  };

  normalizeDoctorMatchKey = (value) => {
    let text = this.normalizeText(value).toLowerCase();

    if (!text) return "";

    text = text.replace(/\b(rpsgt|rgt|phd|m\.?d\.?|dr\.?)\b/g, " ");
    text = text.replace(/[.,]/g, " ");
    text = text.replace(/\s+/g, " ").trim();

    return text;
  };

  loadDoctorsMap = async () => {
    const doctorSnap = await getDocs(collection(db, "doctors"));
    const doctorMap = {};

    doctorSnap.forEach((docSnap) => {
      const data = docSnap.data() || {};
      const fullNameEnKey = this.normalizeDoctorMatchKey(data.fullnameEn);

      if (fullNameEnKey) {
        doctorMap[fullNameEnKey] = {
          name: data.name || "",
          fullnameEn: data.fullnameEn || "",
          raw: data,
        };
      }
    });

    return doctorMap;
  };

  getMappedDoctorName = (doctorMap, excelDoctorValue) => {
    const doctorKey = this.normalizeDoctorMatchKey(excelDoctorValue);
    if (!doctorKey) return "";

    if (doctorMap[doctorKey]) {
      return doctorMap[doctorKey].name || "";
    }

    const keys = Object.keys(doctorMap);
    const matchedKey = keys.find(
      (key) => key.includes(doctorKey) || doctorKey.includes(key),
    );

    if (matchedKey) {
      return doctorMap[matchedKey].name || "";
    }

    return "";
  };

  sanitizeSheetName = (name) => {
    const clean = String(name || "Sheet")
      .replace(/[\\\/\?\*\[\]\:]/g, " ")
      .trim();
    return clean.slice(0, 31) || "Sheet";
  };

  downloadImportErrorFile = (errorBuckets) => {
    const bucketKeys = Object.keys(errorBuckets || {});
    if (bucketKeys.length === 0) return;

    const wb = XLSX.utils.book_new();

    bucketKeys.forEach((bucketName) => {
      const rows = errorBuckets[bucketName];
      if (!rows || rows.length === 0) return;

      const ws = XLSX.utils.json_to_sheet(rows);
      XLSX.utils.book_append_sheet(wb, ws, this.sanitizeSheetName(bucketName));
    });

    const filename = `error_add_batch_booking_${new Date().toISOString().slice(0, 10)}.xlsx`;
    XLSX.writeFile(wb, filename);
    return filename;
  };

  pushImportError = (errorBuckets, bucketName, rowData) => {
    if (!errorBuckets[bucketName]) {
      errorBuckets[bucketName] = [];
    }
    errorBuckets[bucketName].push(rowData);
  };

  makeOrderDuplicateKey = (nodeName, order) => {
    return [
      this.normalizeText(nodeName).toLowerCase(),
      this.normalizeText(order).toLowerCase(),
    ].join("|");
  };

  hasDuplicateBookingOrder = async (nodeName, order) => {
    const cleanNode = this.normalizeText(nodeName);
    const cleanOrder = this.normalizeText(order);

    const q = query(
      collectionGroup(db, "bookings"),
      where("extendedProps.order", "==", cleanOrder),
      limit(50),
    );

    const snap = await getDocs(q);

    let exists = false;

    snap.forEach((docSnap) => {
      const data = docSnap.data() || {};
      const ep = data.extendedProps || {};

      if (this.normalizeText(ep.node) === cleanNode) {
        exists = true;
      }
    });

    return exists;
  };

  saveBookingToFirestore = async (bookingPayload) => {
    const nodeNameToIdMap = this.createNodeNameToIdMap();
    const nodeId = nodeNameToIdMap[bookingPayload.extendedProps.node];

    if (!nodeId) {
      throw new Error(`Node not found: ${bookingPayload.extendedProps.node}`);
    }

    await assertNodeAcceptsNewBooking(nodeId);
    const bookingRef = doc(collection(db, "nodes", nodeId, "bookings"));

    const payloadToSave = {
      title: bookingPayload.title,
      id: bookingPayload.id,
      start: bookingPayload.start,
      end: bookingPayload.end,
      color: bookingPayload.color,
      extendedProps: {
        ...bookingPayload.extendedProps,
        uuid: bookingRef.id,
      },
    };

    await setDoc(bookingRef, payloadToSave);

    return bookingRef.id;
  };

  handleBatchFileSelect = (evt) => {
    const file = evt.target.files && evt.target.files[0];

    if (!file) {
      this.setState({
        batchImportFile: null,
        batchImportFileName: "",
      });
      return;
    }

    this.setState({
      batchImportFile: file,
      batchImportFileName: file.name,
    });
  };

  getTargetNodeIndexesForMigration = () => {
    if (this.state.nodeBy && this.state.nodeBy !== "ทั้งหมด") {
      const index = this.state.nodeList.indexOf(this.state.nodeBy);
      return index >= 0 ? [index] : [];
    }

    return this.state.nodeList.map((_, index) => index);
  };

  handleMigrateCustomerBookingsToNodeBookings = async () => {
    const confirm = await swal({
      title: "Migrate customer bookings?",
      text: "This will copy bookings from nodes/{nodeId}/customers/{customerId}/bookings to nodes/{nodeId}/bookings, then delete the old customer bookings.",
      icon: "warning",
      buttons: ["Cancel", "Confirm"],
      dangerMode: true,
    });

    if (!confirm) return;

    this.setState({ isMigratingCustomerBookings: true });

    try {
      const targetIndexes = this.getTargetNodeIndexesForMigration();

      if (!targetIndexes.length) {
        notifyError("No node selected for migration");
        this.setState({ isMigratingCustomerBookings: false });
        return;
      }

      let movedCount = 0;
      let deletedCount = 0;
      let errorCount = 0;
      const errorBuckets = {};
      console.log("Starting migration for node indexes: ", targetIndexes);
      // console.log("Node list: ", this.state.nodeList);
      console.log("Node ID list: ", this.state.nodeIdDocs);

      for (let idx = 0; idx < targetIndexes.length; idx++) {
        const nodeIndex = targetIndexes[idx];
        const nodeId = this.state.nodeIdDocs[nodeIndex];
        const nodeName = this.state.nodeList[nodeIndex];
        console.log(`Migrating node: ${nodeName} (ID: ${nodeId})`);

        if (!nodeId) continue;

        const customerDocs = await getDocs(
          collection(db, "nodes", nodeId, "customers"),
        );

        for (let c = 0; c < customerDocs.docs.length; c++) {
          const customerDoc = customerDocs.docs[c];
          const customerId = customerDoc.id;
          const customerData = customerDoc.data() || {};
          const customerNameEN = this.normalizeText(
            customerData.CustomerNameEN || customerId,
          );

          const bookingSnap = await getDocs(
            collection(
              db,
              "nodes",
              nodeId,
              "customers",
              customerId,
              "bookings",
            ),
          );

          for (let b = 0; b < bookingSnap.docs.length; b++) {
            const bookingDoc = bookingSnap.docs[b];
            const bookingData = bookingDoc.data() || {};

            try {
              const rootBookingRef = doc(
                db,
                "nodes",
                nodeId,
                "bookings",
                bookingDoc.id,
              );

              const updatedBookingData = {
                ...bookingData,
                extendedProps: {
                  ...(bookingData.extendedProps || {}),
                  node:
                    this.normalizeText(
                      bookingData.extendedProps &&
                        bookingData.extendedProps.node,
                    ) || nodeName,
                  customer:
                    this.normalizeText(
                      bookingData.extendedProps &&
                        bookingData.extendedProps.customer,
                    ) || customerId,
                  customerNameEN:
                    this.normalizeText(
                      bookingData.extendedProps &&
                        bookingData.extendedProps.customerNameEN,
                    ) || customerNameEN,
                  uuid:
                    this.normalizeText(
                      bookingData.extendedProps &&
                        bookingData.extendedProps.uuid,
                    ) || bookingDoc.id,
                },
              };

              await setDoc(rootBookingRef, updatedBookingData, { merge: true });
              movedCount += 1;

              await deleteDoc(bookingDoc.ref);
              deletedCount += 1;
            } catch (moveError) {
              errorCount += 1;
              this.pushImportError(errorBuckets, "MigrateErr", {
                nodeId: nodeId,
                nodeName: nodeName,
                customerId: customerId,
                customerNameEN: customerNameEN,
                bookingId: bookingDoc.id,
                order: this.normalizeText(
                  bookingData.extendedProps && bookingData.extendedProps.order,
                ),
                reason: moveError.message || "Unknown migration error",
              });
            }
          }
        }
      }

      if (errorCount > 0) {
        this.downloadImportErrorFile(errorBuckets);
      }

      await this.fetchInitialData();
      this.setState({
        triggerRerender: true,
        isMigratingCustomerBookings: false,
      });

      swal({
        title: "Migration finished",
        text:
          "Moved: " +
          movedCount +
          " booking(s)\nDeleted old customer bookings: " +
          deletedCount +
          " booking(s)\nError: " +
          errorCount +
          " booking(s)",
        icon: errorCount > 0 ? "warning" : "success",
      });
    } catch (error) {
      console.log("Migration error:", error);
      notifyError("Migrate customer bookings failed");
      this.setState({ isMigratingCustomerBookings: false });
    }
  };

  chunkRows = (rows, chunkSize = 200) => {
    const chunks = [];
    for (let i = 0; i < rows.length; i += chunkSize) {
      chunks.push(rows.slice(i, i + chunkSize));
    }
    return chunks;
  };

  handleBatchImportBooking = async () => {
    if (this.state.isSubmittingBatchImport) return;
    const file = this.state.batchImportFile;
    if (!file) {
      notifyError("Please select xlsx file first", BOOKING_IMPORT_TOAST_OPTIONS);
      return;
    }

    this.setState({ isSubmittingBatchImport: true });

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, {
        type: "array",
        cellDates: true,
      });

      const firstSheetName = workbook.SheetNames[0];
      const firstSheet = workbook.Sheets[firstSheetName];
      const rows = this.convertSheetToObjects(firstSheet);

      if (!rows.length) {
        notifyError("ไม่พบข้อมูลในไฟล์", BOOKING_IMPORT_TOAST_OPTIONS);
        this.setState({ isSubmittingBatchImport: false });
        return;
      }

      const headers = rows.length
        ? Object.keys(rows[0]).filter((k) => k !== "__rowNum")
        : [];

      const orderKey = this.findHeaderKey(headers, [
        "Sleep Study No.",
        "Sleep Study No",
      ]);
      const statusKey = this.findHeaderKey(headers, ["Status ล่าสุด"]);
      const customerKey = this.findHeaderKey(headers, ["โรงพยาบาลผู้ส่งตรวจ"]);
      const fullNameKey = this.findHeaderKey(headers, [
        "ชื่อ - นามสกุล",
        "ชื่อ-นามสกุล",
      ]);
      const sleepDateKey = this.findHeaderKey(headers, [
        "วันที่ตรวจการนอนหลับ",
      ]);
      const doctorReadKey = this.findHeaderKey(headers, ["แพทย์อ่านผล"]);
      const remarkKey = this.findHeaderKey(headers, ["หมายเหตุ"]);
      const packageKey = this.findHeaderKey(headers, ["รายละเอียดแพ็คเกจ"]);
      const scoringTechKey = this.findHeaderKey(headers, ["Scoring Tech"]);
      const recordingTechKey = this.findHeaderKey(headers, ["Recording Tech"]);

      const patientMap = await this.loadPatientsMap();
      const doctorMap = await this.loadDoctorsMap();
      const nodeCustomerMap = this.createNodeCustomerNameEnMap();

      let successCount = 0;
      const errorBuckets = {};
      const customerReviewRows = [];
      const seenOrderInBatch = new Set();

      const rowChunks = this.chunkRows(rows, 200);

      for (let chunkIndex = 0; chunkIndex < rowChunks.length; chunkIndex++) {
        const chunk = rowChunks[chunkIndex];

        for (let i = 0; i < chunk.length; i++) {
          const row = chunk[i];
          if (!row) continue;

          try {
            const order = this.normalizeText(row[orderKey]);
            const status = this.normalizeText(row[statusKey]);
            const customer = this.normalizeText(row[customerKey]);
            const fullName = this.normalizeText(row[fullNameKey]);
            const studyDateString = this.formatExcelDateToString(
              row[sleepDateKey],
            );
            const studyDate = this.getJSDateFromExcelValue(row[sleepDateKey]);

            if (!order || !fullName || !studyDateString || !studyDate) {
              this.pushImportError(errorBuckets, "Missing", {
                excelRow: row.__rowNum,
                sleepStudyNo: order,
                customer: customer,
                fullName: fullName,
                reason:
                  "Missing required field: Sleep Study No. / ชื่อ - นามสกุล / วันที่ตรวจการนอนหลับ",
              });
              continue;
            }

            const matchedNodeCustomer = this.findNodeNameByOrderAndCustomer(
              order,
              customer,
              nodeCustomerMap,
            );

            const nodeName = matchedNodeCustomer.nodeName;
            const matchedCustomerId = matchedNodeCustomer.customerId;

            if (!nodeName) {
              this.pushImportError(errorBuckets, "Node", {
                excelRow: row.__rowNum,
                sleepStudyNo: order,
                customer: customer,
                fullName: fullName,
                reason:
                  "Node not found from CustomerNameEN/customerId / Sleep Study No. rule",
              });
              continue;
            }

            if (!matchedCustomerId && customer) {
              this.pushImportError(errorBuckets, "Node", {
                excelRow: row.__rowNum,
                sleepStudyNo: order,
                customer: customer,
                fullName: fullName,
                reason:
                  "Customer is missing or does not match this node. A blank customer defaults only when the node has exactly one customer.",
              });
              continue;
            }

            const duplicateKey = this.makeOrderDuplicateKey(nodeName, order);

            if (seenOrderInBatch.has(duplicateKey)) {
              continue;
            }

            if (await this.hasDuplicateBookingOrder(nodeName, order)) {
              continue;
            }

            const splitName = this.splitThaiFullName(fullName);
            const firstname = splitName.firstname;
            const lastname = splitName.lastname;

            const patientKey = this.normalizeNameKey(firstname, lastname);
            const patientInfo = patientMap[patientKey];

            if (!patientInfo || !patientInfo.hn) {
              this.pushImportError(errorBuckets, "Patient", {
                excelRow: row.__rowNum,
                sleepStudyNo: order,
                customer: customer,
                fullName: fullName,
                firstname: firstname,
                lastname: lastname,
                reason:
                  "Patient HN not found from collection patients by firstnameTh + lastnameTh",
              });
              continue;
            }

            const mappedDoctorName = this.getMappedDoctorName(
              doctorMap,
              row[doctorReadKey],
            );

            if (this.normalizeText(row[doctorReadKey]) && !mappedDoctorName) {
              this.pushImportError(errorBuckets, "Doctor", {
                excelRow: row.__rowNum,
                sleepStudyNo: order,
                customer: customer,
                fullName: fullName,
                importDoctorFullnameEn: this.normalizeText(row[doctorReadKey]),
                reason: "Doctor fullnameEn not found in collection doctors",
              });
              continue;
            }

            const bookingPayload = {
              title: order,
              id: this.createRandomId(),
              start: studyDate,
              end: null,
              color: this.getStatusColor(status),
              extendedProps: {
                order: order,
                hn: patientInfo.hn,
                type: this.getMappedTypeFromRow(row),
                status: status,
                firstname: firstname,
                lastname: lastname,
                nationalId: "",
                healthInsurance: this.getHealthInsuranceFromRow(row),
                phone: "",
                note: this.buildNote(row[remarkKey], row[packageKey]),
                node: nodeName,
                customer: matchedCustomerId,
                customerNameEN: matchedNodeCustomer.customerNameEN || "",
                items: [],
                totalValue: "",
                time: "",
                doctor: mappedDoctorName,
                technician: this.normalizeText(row[scoringTechKey]),
                techrecord: this.normalizeText(row[recordingTechKey]),
                referDoctor: "",
                postDoctor: "",
                latestSleepStudyDate: studyDateString,
                ahi: this.getMappedAHIFromRow(row),
                hospitalNumber: "",
                gender: patientInfo.gender || "",
                createBy: this.context.currentUser.displayName,
                updatedBy: this.context.currentUser.displayName,
                uuid: "",
              },
            };

            const bookingId = await this.saveBookingToFirestore(bookingPayload);

            seenOrderInBatch.add(duplicateKey);
            successCount += 1;
            if (!matchedCustomerId) {
              customerReviewRows.push({
                excelRow: row.__rowNum,
                sleepStudyNo: order,
                node: nodeName,
                customer: "",
                hn: patientInfo.hn,
                fullName: fullName,
                bookingId,
                reason:
                  "Booking imported with a blank customer. No unique customer could be selected automatically; please review and select the correct customer in the booking event.",
              });
            }
          } catch (rowError) {
            this.pushImportError(errorBuckets, "Unknown", {
              excelRow: row ? row.__rowNum : "",
              sleepStudyNo: row ? this.normalizeText(row[orderKey]) : "",
              customer: row ? this.normalizeText(row[customerKey]) : "",
              fullName: row ? this.normalizeText(row[fullNameKey]) : "",
              reason: rowError.message || "Unknown error",
            });
          }
        }

        await new Promise((resolve) => setTimeout(resolve, 0));
      }

      this.setState({
        triggerRerender: true,
        batchImportFile: null,
        batchImportFileName: "",
        isSubmittingBatchImport: false,
      });

      const totalErrorCount = Object.values(errorBuckets).reduce(
        (sum, arr) => sum + arr.length,
        0,
      );

      const hasImportLog = totalErrorCount > 0 || customerReviewRows.length > 0;
      let logMessage = "";
      let logDownloadFailed = false;
      if (hasImportLog) {
        try {
          const logFilename = this.downloadImportErrorFile({
            ...errorBuckets,
            ...(customerReviewRows.length > 0
              ? { "Customer Review": customerReviewRows }
              : {}),
          });
          logMessage = `Error/review log download started: ${logFilename}`;
        } catch (downloadError) {
          console.error("Booking import log download failed:", downloadError);
          logDownloadFailed = true;
          logMessage = "Unable to download the error/review log file.";
        }
      }

      if (this.fileInputRef.current) {
        this.fileInputRef.current.value = "";
      }

      const notifyResult = totalErrorCount > 0 || logDownloadFailed
        ? notifyError
        : customerReviewRows.length > 0 ? notifyWarning : notifyTopRight;
      notifyResult(
        "Batch import finished\nFile: " +
          file.name +
          "\n\nSuccess: " +
          successCount +
          " row(s)\n" +
          "Error: " +
          totalErrorCount +
          " row(s)\n" +
          "Customer review (imported): " +
          customerReviewRows.length +
          " row(s)\n\n" +
          logMessage,
        BOOKING_IMPORT_TOAST_OPTIONS,
      );
    } catch (error) {
      console.log("Batch import booking error:", error);
      notifyError("Import batch booking failed", BOOKING_IMPORT_TOAST_OPTIONS);
      this.setState({ isSubmittingBatchImport: false });

      if (this.fileInputRef.current) {
        this.fileInputRef.current.value = "";
      }
    }
  };

  handleAddItem = () => {
    const newItem = {
      id: this.state.items.length + 1,
      itemcode: this.state.itemList[0].itemcode,
      item: this.state.itemList[0].item,
      unitcost: this.state.itemList[0].unitcost,
      qty: 1,
      discount: 0,
      total: this.state.itemList[0].unitcost,
    };
    const updatedItems = [...this.state.items, newItem];
    this.setState({ items: updatedItems });
    const newTotalValue = this.calculateTotalValue(updatedItems);
    this.setState({ totalValue: newTotalValue });
  };

  onUpdateItemValue = (key, index, value) => {
    var tmpItems = this.state.items;
    tmpItems[index][key] = value.target.value;
    tmpItems[index].total =
      tmpItems[index].unitcost * tmpItems[index].qty - tmpItems[index].discount;
    this.setState({ items: tmpItems });
    const newTotalValue = this.calculateTotalValue(tmpItems);
    this.setState({ totalValue: newTotalValue });
  };

  calculateTotalValue = (itemsList) => {
    let totalValueTmp = 0;
    itemsList.forEach((item) => {
      totalValueTmp += parseInt(item.total || 0, 10);
    });
    return totalValueTmp;
  };

  handleDate = (moment, props) => {
    let storeMoment = moment.toISOString().slice(0, 10);
    this.setState({ dateTmp: storeMoment });
  };

  handleTime = (moment, props) => {
    let storeMoment = moment.target.value;
    this.setState({ timeTmp: storeMoment });
  };

  handleStatusChange = () => {
    const selectedStatus = this.statusRef.current.value;
    if (selectedStatus === "Post-Consult") {
      this.setState({ isDatetime: true });
    } else {
      this.setState({ isDatetime: false });
    }
  };

  onSearchPatient = async () => {
    const q = query(
      collection(db, "patients"),
      where("hn", "==", this.hnRef.current.value),
    );
    const querySnapshot = await getDocs(q);
    let listPatient = [];

    querySnapshot.forEach((docItem) => {
      listPatient.push(docItem.data());
    });

    const visiblePatients = filterRecordsByStaffCustomerAccess({
      records: listPatient,
      currentUser: this.context.currentUser,
      adminData: this.state.currentAdmin,
      nodes: this.state.allowedNodeDocs,
      getNodeValue: (patient) => patient.nodeRef,
      getCustomerValue: (patient) => patient.refCustomer,
    });

    if (listPatient.length > 0 && visiblePatients.length === 0) {
      notifyWarning("This patient is not available for your account");
      this.setState({ isNewPatient: false });
      return;
    }

    listPatient = visiblePatients;

    if (listPatient[0] === undefined) {
      this.setState({ isNewPatient: true });
    } else {
      try {
        this.nodeRef.current.value = listPatient[0].nodeRef;
        this.setState(
          {
            customerList: this.CustomerList(listPatient[0].nodeRef),
          },
          () => {
            this.customerRef.current.value = listPatient[0].refCustomer;
            this.firstnameRef.current.value = listPatient[0].firstnameTh;
            this.lastnameRef.current.value = listPatient[0].lastnameTh;
            this.phoneRef.current.value = listPatient[0].mobile;
            this.hospitalNumberRef.current.value = listPatient[0].refHn;
            this.genderRef.current.value = listPatient[0].gender;

            if (
              listPatient[0].healthInsurance === "" ||
              listPatient[0].healthInsurance === "please-select"
            ) {
              this.healthInsuranceRef.current.value = "กรุณาเลือก";
            } else {
              this.healthInsuranceRef.current.value =
                listPatient[0].healthInsurance;
            }
          },
        );

        this.firstnameRef.current.value = listPatient[0].firstnameTh;
        this.lastnameRef.current.value = listPatient[0].lastnameTh;
        this.phoneRef.current.value = listPatient[0].mobile;
        this.hospitalNumberRef.current.value = listPatient[0].refHn;
        this.genderRef.current.value = listPatient[0].gender;

        if (
          listPatient[0].healthInsurance === "" ||
          listPatient[0].healthInsurance === "please-select"
        ) {
          this.healthInsuranceRef.current.value = "กรุณาเลือก";
        } else {
          this.healthInsuranceRef.current.value =
            listPatient[0].healthInsurance;
        }
      } catch (err) {
        console.log(err);
      }

      this.setState({ isNewPatient: false });
    }
  };

  CustomerList = (nodename) => {
    const index = this.state.nodeList.indexOf(nodename);
    return this.state.customerAllList[index];
  };

  onAddEvent = async () => {
    const currentUserName = this.context.currentUser.displayName;
    var indexOfStatusList = statusList.findIndex(
      (obj) => obj === this.statusRef.current.value,
    );
    var currentLatestSleepStudy;

    if (this.statusRef.current.value === "Sleep Test Scheduled") {
      currentLatestSleepStudy = this.state.dateTmp;
    } else {
      currentLatestSleepStudy = "";
    }

    var colorTmp = colorList[indexOfStatusList];
    var event = {
      title: this.orderRef.current.value,
      start: this.state.dateTmp,
      id: 6,
      end: null,
      color: colorTmp,
      extendedProps: {
        customer: this.customerRef.current.value,
        doctor: this.docRef.current.value,
        firstname: this.firstnameRef.current.value,
        healthInsurance: this.healthInsuranceRef.current.value,
        hn: this.hnRef.current.value,
        items: this.state.items,
        lastname: this.lastnameRef.current.value,
        nationalId: "",
        node: this.nodeRef.current.value,
        sale: this.getBookingSaleValueForSave(),
        note: this.noteRef.current.value,
        order: this.orderRef.current.value,
        phone: this.phoneRef.current.value,
        status: this.statusRef.current.value,
        technician: this.techRef.current.value,
        time: this.state.timeTmp,
        totalValue: this.state.totalValue,
        type: this.typeRef.current.value,
        additionalEquipment: readBookingAdditionalEquipment(this.additionalEquipmentRefs),
        referDoctor: this.referDocRef.current.value,
        techrecord: this.techRecordRef.current.value,
        techConsult: this.techConsultRef.current.value,
        postDoctor: this.postDoctorRef.current.value,
        latestSleepStudyDate: currentLatestSleepStudy,
        ahi: this.ahiRef.current.value,
        hospitalNumber: this.hospitalNumberRef.current.value,
        createBy: currentUserName,
        updatedBy: currentUserName,
        gender: this.genderRef.current.value,
      },
    };

    await setEvent(
      event,
      undefined,
      this.state.nodeIdDocs,
      this.state.nodeList,
    );

    this.setState({ triggerRerender: true });
    this.setState({ isAddEventModal: false });
  };

  onSearchChange = (e) => {
    setTimeout(() => {
      this.setState({ textSearch: e.target.value });
    }, 800);
  };

  onFilterChange = (option) => {
    this.setState({ sortBy: `${option}` });
  };

  onTypeChange = (option) => {
    this.setState({ typeBy: `${option}` });
  };

  onStatusChange = (option) => {
    this.setState({ statusBy: `${option}` });
  };

  onNodeChange = (option) => {
    this.setState({ nodeBy: `${option}` });
  };

  onGetTitleSort = (key) => {
    const index = this.sortKey.indexOf(key);
    return this.sortTitle[index];
  };

  resetTriggerRerender = () => {
    this.setState({ triggerRerender: false });
  };

  onTechChange = (option) => {
    this.setState({ techBy: `${option}` });
  };

  render() {
    return (
      <React.Fragment>
        <PageTitle
          activeMenu="Table"
          motherMenu="Booking"
          motherLink="/booking-calendar"
        />
        <Toast />

        <div className="form-head d-flex mb-3 mb-lg-5 align-items-start">
          {![("staff", "sale", "accountant", "sleep_technician")].includes(
            this.context.currentUser.roles[0],
          ) && (
            <>
              <Button
                onClick={() => {
                  this.setState({ isAddEventModal: true });
                  this.setState({
                    dateTmp: new Date().toISOString().slice(0, 10),
                  });
                  this.setState({ timeTmp: "" });
                  this.setState({ isDatetime: false });
                  this.setState({ isNewPatient: false });
                  this.setState({
                    customerList: this.state.customerAllList[0],
                  });
                }}
                className="btn-md btn-danger"
              >
                + New Booking
              </Button>

              <Button
                className="btn-md btn-primary ml-2"
                onClick={() => {
                  if (this.fileInputRef.current) {
                    this.fileInputRef.current.click();
                  }
                }}
              >
                Choose Batch File
              </Button>

              {/* <Button
                className="btn-md btn-warning ml-2"
                onClick={this.handleMigrateCustomerBookingsToNodeBookings}
                disabled={this.state.isMigratingCustomerBookings}
              >
                {this.state.isMigratingCustomerBookings
                  ? "Migrating..."
                  : "Fetch Customer Bookings"}
              </Button> */}

              <input
                type="file"
                accept=".xlsx,.xls"
                ref={this.fileInputRef}
                style={{ display: "none" }}
                onChange={this.handleBatchFileSelect}
              />

              {this.state.batchImportFileName ? (
                <div className="ml-2 d-inline-flex align-items-center">
                  <span
                    className="badge badge-light"
                    style={{
                      padding: "10px 12px",
                      fontSize: "0.85rem",
                      maxWidth: "320px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      border: "1px solid #ddd",
                    }}
                    title={this.state.batchImportFileName}
                  >
                    {this.state.batchImportFileName}
                  </span>

                  <Button
                    className="btn-md btn-success ml-2"
                    onClick={this.handleBatchImportBooking}
                    disabled={this.state.isSubmittingBatchImport}
                  >
                    {this.state.isSubmittingBatchImport
                      ? "Submitting..."
                      : "Submit Batch"}
                  </Button>

                  <Button
                    className="btn-md btn-outline-secondary ml-2"
                    onClick={() => {
                      this.setState({
                        batchImportFile: null,
                        batchImportFileName: "",
                      });
                      if (this.fileInputRef.current) {
                        this.fileInputRef.current.value = "";
                      }
                    }}
                    disabled={this.state.isSubmittingBatchImport}
                  >
                    Clear
                  </Button>
                </div>
              ) : null}
            </>
          )}

          <div className="input-group search-area ml-auto d-inline-flex">
            <input
              type="text"
              className="form-control"
              placeholder="Search here"
              onChange={this.onSearchChange}
            />
            <div className="input-group-append">
              <span className="input-group-text c-pointer">
                <i className="flaticon-381-search-2"></i>
              </span>
            </div>
          </div>

          <Dropdown
            className="align-items-end d-inline-flex ml-2"
            onSelect={this.onFilterChange}
          >
            <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
              <i className="flaticon-381-controls-3 "></i> by{" "}
              {this.onGetTitleSort(this.state.sortBy)}
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-right">
              <Dropdown.Item href="#" eventKey={"firstname"}>
                Name
              </Dropdown.Item>
              <Dropdown.Item href="#" eventKey={"order"}>
                Sleep Study
              </Dropdown.Item>
              <Dropdown.Item href="#" eventKey={"hn"}>
                HN
              </Dropdown.Item>
              <Dropdown.Item href="#" eventKey={"start"}>
                Activity Date
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <div className="form-head d-flex mb-3 mb-lg-5 justify-content-end align-items-end">
          <Dropdown
            className="align-items-end d-inline-flex ml-2"
            onSelect={this.onTypeChange}
          >
            <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
              <i className="flaticon-381-menu-1"></i>
              {this.state.typeBy === "ทั้งหมด" && "Type"} {this.state.typeBy}
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-right">
              <Dropdown.Item href="#" eventKey={"ทั้งหมด"}>
                ทั้งหมด
              </Dropdown.Item>
              {typeList.map((element, index) => {
                return (
                  <Dropdown.Item href="#" eventKey={element} key={index}>
                    {element}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          <select
            aria-label="Report readiness on this page"
            title="Filter reports on the current table page"
            className="form-control ml-2 w-auto"
            value={this.state.reportBy}
            onChange={(event) => this.setState({ reportBy: event.target.value })}
          >
            <option value="all">All Reports</option>
            <option value="ready">Report Ready</option>
            <option value="not_ready">Report Not Ready</option>
          </select>

          <Dropdown
            className="align-items-end d-inline-flex ml-2"
            onSelect={this.onStatusChange}
          >
            <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
              <i className="flaticon-381-menu-1"></i>
              {this.state.statusBy === "ทั้งหมด" && "Status"}{" "}
              {this.state.statusBy}
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-right">
              <Dropdown.Item href="#" eventKey={"ทั้งหมด"}>
                ทั้งหมด
              </Dropdown.Item>
              {statusList.map((element, index) => {
                return (
                  <Dropdown.Item href="#" eventKey={element} key={index}>
                    {element}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          <Dropdown
            className="align-items-end d-inline-flex ml-2"
            onSelect={this.onNodeChange}
          >
            <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
              <i className="flaticon-381-menu-1"></i>
              {(this.context.currentUser.roles[0] === "super_admin" ||
                this.context.currentUser.roles[0] === "sleep_physician" ||
                this.context.currentUser.roles[0] === "sleep_technician" ||
                this.context.currentUser.roles[0] === "sale" ||
                this.context.currentUser.roles[0] === "accountant" ||
                this.context.currentUser.roles[0] === "admin") &&
                this.state.nodeBy === "ทั้งหมด" &&
                "Node "}
              {this.state.nodeBy}
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-right">
              {(this.context.currentUser.roles[0] === "super_admin" ||
                this.context.currentUser.roles[0] === "sleep_physician" ||
                this.context.currentUser.roles[0] === "sleep_technician" ||
                this.context.currentUser.roles[0] === "sale" ||
                this.context.currentUser.roles[0] === "accountant") && (
                <Dropdown.Item href="#" eventKey={"ทั้งหมด"}>
                  ทั้งหมด
                </Dropdown.Item>
              )}
              {["super_admin", "sale", "accountant", "staff", "admin"].includes(
                this.context.currentUser.roles[0],
              ) &&
                this.state.nodeList.map((element, index) => {
                  return (
                    <Dropdown.Item key={index} href="#" eventKey={element}>
                      {element}
                    </Dropdown.Item>
                  );
                })}
            </Dropdown.Menu>
          </Dropdown>

          {this.context.currentUser.roles[0] === "super_admin" && (
            <Dropdown
              className="align-items-end d-inline-flex ml-2"
              onSelect={this.onTechChange}
            >
              <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
                <i className="flaticon-381-menu-1"></i>
                {"Tech Record "}
                {this.state.techBy}
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu-right">
                {this.state.technicianList.map((element, index) => {
                  return (
                    <Dropdown.Item href="#" eventKey={element} key={index}>
                      {element}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          )}

          <Button
            onClick={() => {
              this.setState({ sortBy: "hn" });
              this.setState({ typeBy: "ทั้งหมด" });
              this.setState({ statusBy: "ทั้งหมด", reportBy: "all" });
              if (
                this.context.currentUser.roles[0] === "super_admin" ||
                this.context.currentUser.roles[0] === "sleep_physician" ||
                this.context.currentUser.roles[0] === "sleep_technician" ||
                this.context.currentUser.roles[0] === "sale" ||
                this.context.currentUser.roles[0] === "accountant"
              ) {
                this.setState({ nodeBy: "ทั้งหมด" });
                this.setState({ techBy: "กรุณาเลือก" });
              }
            }}
            className="btn-md btn-danger align-items-end d-inline-flex ml-2"
          >
            Reset
          </Button>
        </div>

        <BookingTable
          text={this.state.textSearch}
          sortBy={this.state.sortBy}
          typeBy={this.state.typeBy}
          statusBy={this.state.statusBy}
          reportBy={this.state.reportBy}
          nodeBy={this.state.nodeBy}
          techBy={this.state.techBy}
          triggerRerender={this.state.triggerRerender}
          onResetTriggerRerender={this.resetTriggerRerender}
        />

        <Modal
          className="fade bd-example-modal-lg"
          show={this.state.isAddEventModal}
          onHide={() => this.setState({ isAddEventModal: false })}
          size="xl"
        >
          <Modal.Header>
            <Modal.Title>Add Event</Modal.Title>
            <Button
              variant=""
              className="close"
              onClick={() => this.setState({ isAddEventModal: false })}
            >
              <span>&times;</span>
            </Button>
          </Modal.Header>

          <Modal.Body>
            <div className="card-body">
              <div className="row">
                <div className="col-xl-12">
                  <div className="form-group row">
                    <label
                      className="col-lg-3 col-form-label"
                      htmlFor="val-username"
                    >
                      Order
                    </label>

                    <div className="col-lg-5">
                      <input
                        type="text"
                        className="form-control"
                        id="val-hn"
                        name="val-hn"
                        placeholder="Order"
                        ref={this.orderRef}
                        defaultValue={eventTmp.extendedProps.order}
                      />
                    </div>
                  </div>

                  <PatientDropDownForm
                    title="Node"
                    id="node"
                    refvalue={this.nodeRef}
                    selected={eventTmp.extendedProps.node}
                    options={this.state.nodeList}
                    onChange={(e) => {
                      this.setState({
                        customerList: this.CustomerList(e.target.value),
                      });
                    }}
                  />

                  <PatientDropDownForm
                    title="Customer"
                    id="customer"
                    refvalue={this.customerRef}
                    selected={eventTmp.extendedProps.customer}
                    options={this.state.customerList}
                  />

                  <div className="form-group row">
                    <label
                      className="col-lg-3 col-form-label"
                      htmlFor="val-username"
                    >
                      HN (Company Number)
                    </label>

                    <div className="col-lg-7">
                      <input
                        type="text"
                        className="form-control"
                        id="val-hn"
                        name="val-hn"
                        placeholder="HN"
                        ref={this.hnRef}
                        defaultValue={eventTmp.extendedProps.hn}
                      />
                    </div>
                    <div className="col-lg-2">
                      <Button
                        variant=""
                        type="button"
                        className="btn btn-secondary"
                        onClick={this.onSearchPatient}
                        size="sm"
                      >
                        Search
                      </Button>
                    </div>
                  </div>

                  {this.state.isNewPatient ? (
                    <div className="form-group row">
                      <label
                        className="col-lg-3 col-form-label"
                        htmlFor="val-username"
                      ></label>

                      <div className="col-lg-4">
                        <label className="text-danger">* New Patient</label>
                      </div>
                    </div>
                  ) : null}

                  {eventTmp.extendedProps.hn === "" ||
                  eventTmp.extendedProps.hn === null ||
                  eventTmp.extendedProps.hn === undefined ? (
                    <>
                      <div className="form-group row">
                        <label
                          className="col-lg-3 col-form-label"
                          htmlFor="val-username"
                        >
                          Full Name
                        </label>
                        <div className="col-lg-4">
                          <input
                            type="text"
                            className="form-control"
                            id="val-hn"
                            name="val-hn"
                            placeholder="Firstname"
                            ref={this.firstnameRef}
                            defaultValue={eventTmp.extendedProps.firstname}
                          />
                        </div>
                        <div className="col-lg-4">
                          <input
                            type="text"
                            className="form-control"
                            id="val-hn"
                            name="val-hn"
                            placeholder="Lastname"
                            ref={this.lastnameRef}
                            defaultValue={eventTmp.extendedProps.lastname}
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-3 col-form-label"
                          htmlFor="val-username"
                        >
                          Gender
                        </label>

                        <div className="col-lg-8">
                          <input
                            type="text"
                            className="form-control"
                            id="val-hn"
                            name="val-hn"
                            placeholder="Gender"
                            ref={this.genderRef}
                            defaultValue={eventTmp.extendedProps.gender}
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-3 col-form-label"
                          htmlFor="val-username"
                        >
                          Phone
                        </label>
                        <div className="col-lg-5">
                          <input
                            type="text"
                            className="form-control"
                            id="val-phone"
                            name="val-phone"
                            placeholder="Phone"
                            ref={this.phoneRef}
                            defaultValue={eventTmp.extendedProps.phone}
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label
                          className="col-lg-3 col-form-label"
                          htmlFor="val-username"
                        >
                          Referring Hospital Number
                        </label>
                        <div className="col-lg-5">
                          <input
                            type="text"
                            className="form-control"
                            id="val-phone"
                            name="val-phone"
                            placeholder=""
                            ref={this.hospitalNumberRef}
                            defaultValue={eventTmp.extendedProps.hospitalNumber}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <PatientTextInfo
                        title="Full Name"
                        value={
                          eventTmp.extendedProps.firstname +
                          " " +
                          eventTmp.extendedProps.lastname
                        }
                        bold={true}
                      />
                      <PatientTextInfo
                        title="Gender"
                        value={eventTmp.extendedProps.gender}
                        bold={true}
                      />
                      <PatientTextInfo
                        title="Phone"
                        value={eventTmp.extendedProps.phone}
                        bold={true}
                      />
                      <PatientTextInfo
                        title="Referring Hospital Number"
                        value={eventTmp.extendedProps.hospitalNumber}
                        bold={true}
                      />
                    </>
                  )}

                  <PatientDropDownForm
                    title="Health Insurance"
                    id="healthInsurance"
                    refvalue={this.healthInsuranceRef}
                    selected={eventTmp.extendedProps.healthInsurance}
                    options={paymentPrivilages}
                  />

                  <PatientDropDownForm
                    title="Type"
                    id="type"
                    refvalue={this.typeRef}
                    selected={eventTmp.extendedProps.type}
                    options={typeList}
                  />

                  <BookingAdditionalEquipmentField
                    inputRefs={this.additionalEquipmentRefs}
                    idPrefix="add-table-equipment"
                  />

                  <PatientDropDownForm
                    title="Status"
                    id="status"
                    refvalue={this.statusRef}
                    selected={eventTmp.extendedProps.status}
                    options={statusList}
                    onChange={this.handleStatusChange}
                  />

                  <PatientDropDownForm
                    title="Recording Tech"
                    id="technician"
                    refvalue={this.techRecordRef}
                    selected={eventTmp.extendedProps.techrecord}
                    options={this.state.techrecordList}
                  />

                  <PatientDropDownForm
                    title="Scoring Tech"
                    id="technician"
                    refvalue={this.techRef}
                    selected={eventTmp.extendedProps.technician}
                    options={this.state.technicianList}
                  />

                  <PatientDropDownForm
                    title="Post Consult Tech"
                    id="technician"
                    refvalue={this.techConsultRef}
                    selected={eventTmp.extendedProps.techConsult}
                    options={this.state.techrecordList}
                  />

                  <PatientDropDownForm
                    title="Doctor"
                    id="doctor"
                    refvalue={this.docRef}
                    selected={eventTmp.extendedProps.doctor}
                    options={this.state.doctorList}
                  />

                  <div className="form-group row">
                    <label
                      className="col-lg-3 col-form-label"
                      htmlFor="val-username"
                    >
                      Referring Doctor
                    </label>
                    <div className="col-lg-5">
                      <input
                        type="text"
                        className="form-control"
                        id="val-phone"
                        name="val-phone"
                        placeholder="Referring Doctor"
                        ref={this.referDocRef}
                        defaultValue={eventTmp.extendedProps.referDoctor}
                      />
                    </div>
                    <PatientDropDownForm
                      title="Post Consult Doctor"
                      id="doctor"
                      refvalue={this.postDoctorRef}
                      selected={eventTmp.extendedProps.postDoctor}
                      options={this.state.doctorList}
                    />
                    {this.renderBookingSaleField(eventTmp.extendedProps.sale)}
                  </div>

                  <div className="form-group row">
                    <label
                      className="col-lg-3 col-form-label"
                      htmlFor="val-username"
                    >
                      AHI
                    </label>
                    <div className="col-lg-5">
                      <input
                        type="text"
                        className="form-control"
                        id="val-phone"
                        name="val-phone"
                        placeholder=""
                        ref={this.ahiRef}
                        defaultValue={eventTmp.extendedProps.ahi}
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      className="col-lg-3 col-form-label"
                      htmlFor="val-username"
                    >
                      Date
                    </label>
                    <div className="col-lg-8 mt-2">
                      <DatePicker
                        className="form-control"
                        dateFormat="yyyy-MM-dd"
                        selected={new Date(this.state.dateTmp)}
                        onChange={(event, props) =>
                          this.handleDate(event, props)
                        }
                      />
                    </div>
                  </div>

                  {this.state.isDatetime && (
                    <div className="form-group row">
                      <label
                        className="col-lg-3 col-form-label"
                        htmlFor="val-username"
                      >
                        Time
                      </label>
                      <div className="col-lg-2 mt-2">
                        <input
                          type="time"
                          className="form-control"
                          defaultValue={this.state.timeTmp}
                          onChange={(event, props) =>
                            this.handleTime(event, props)
                          }
                        />
                      </div>
                    </div>
                  )}

                  <div className="form-group row">
                    <label
                      className="col-lg-3 col-form-label"
                      htmlFor="val-username"
                    >
                      Note
                    </label>
                    <div className="col-lg-5">
                      <textarea
                        type="area"
                        className="form-control"
                        id="val-phone"
                        name="val-phone"
                        rows="4"
                        placeholder="Note"
                        ref={this.noteRef}
                        defaultValue={eventTmp.extendedProps.note}
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <div className="col-lg-5 col-form-label mt-2">
                      <b htmlFor="val-username">Add Item</b>
                      <Button
                        variant="secondary"
                        size="xs"
                        className="ml-2"
                        onClick={this.handleAddItem}
                      >
                        +
                      </Button>
                    </div>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th className="center">No.</th>
                          <th className="center width300">Item Name</th>
                          <th className="center width100">Item Code</th>
                          <th className="center width150">Unit Cost (THB)</th>
                          <th className="center width100">Qty</th>
                          <th className="center">Discount (THB)</th>
                          <th className="center">Total (THB)</th>
                          <th className="center"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.items.map((element, index) => {
                          return (
                            <tr key={index}>
                              <td>{element.id}</td>
                              <td>
                                <select
                                  className="form-control"
                                  id={"item" + String(index)}
                                  name={"item" + String(index)}
                                  onChange={(evt) => {
                                    var item = evt.target.value;
                                    var tmpItems = this.state.items;

                                    var indexOfItemList =
                                      this.state.itemList.findIndex(
                                        (obj) => obj.item === item,
                                      );

                                    tmpItems[index].itemcode =
                                      this.state.itemList[
                                        indexOfItemList
                                      ].itemcode;
                                    tmpItems[index].item =
                                      this.state.itemList[indexOfItemList].item;
                                    tmpItems[index].unitcost =
                                      this.state.itemList[
                                        indexOfItemList
                                      ].unitcost;
                                    tmpItems[index].qty = 1;
                                    tmpItems[index].discount = 0;
                                    tmpItems[index].total =
                                      this.state.itemList[
                                        indexOfItemList
                                      ].unitcost;

                                    this.setState({ items: tmpItems }, () => {
                                      const newTotalValue =
                                        this.calculateTotalValue(tmpItems);
                                      this.setState({
                                        totalValue: newTotalValue,
                                      });
                                    });
                                  }}
                                >
                                  {this.state.itemList.map((value, itemIdx) => (
                                    <option
                                      key={itemIdx}
                                      value={value.item}
                                      selected={
                                        this.state.items[index].item ===
                                        value.item
                                          ? "selected"
                                          : ""
                                      }
                                    >
                                      {value.item}
                                    </option>
                                  ))}
                                </select>
                              </td>
                              <td className="left strong">
                                <b>{this.state.items[index].itemcode}</b>
                              </td>
                              <td className="left">
                                <input
                                  type="number"
                                  className="form-control"
                                  id={"val-unitcost" + String(index)}
                                  name={"val-unitcost" + String(index)}
                                  placeholder="Unit Cost"
                                  onChange={(value) =>
                                    this.onUpdateItemValue(
                                      "unitcost",
                                      index,
                                      value,
                                    )
                                  }
                                  value={this.state.items[index].unitcost}
                                />
                              </td>
                              <td className="right">
                                <input
                                  type="number"
                                  className="form-control"
                                  id={"val-qty" + String(index)}
                                  name={"val-qty" + String(index)}
                                  placeholder="QTY"
                                  onChange={(value) =>
                                    this.onUpdateItemValue("qty", index, value)
                                  }
                                  value={this.state.items[index].qty}
                                />
                              </td>
                              <td className="center">
                                <input
                                  type="number"
                                  className="form-control"
                                  id={"val-discount" + String(index)}
                                  name={"val-discount" + String(index)}
                                  placeholder="Discount"
                                  onChange={(value) =>
                                    this.onUpdateItemValue(
                                      "discount",
                                      index,
                                      value,
                                    )
                                  }
                                  value={this.state.items[index].discount}
                                />
                              </td>
                              <td className="right">
                                <input
                                  type="number"
                                  className="form-control"
                                  id={"val-total" + String(index)}
                                  name={"val-total" + String(index)}
                                  placeholder="Total"
                                  onChange={(value) =>
                                    this.onUpdateItemValue(
                                      "total",
                                      index,
                                      value,
                                    )
                                  }
                                  value={this.state.items[index].total}
                                />
                              </td>
                              <td>
                                <Button
                                  className="btn btn-danger btn-xs sharp"
                                  onClick={() => {
                                    var tmpItems = this.state.items;
                                    tmpItems = tmpItems.filter(
                                      (item) => item.id !== tmpItems[index].id,
                                    );
                                    for (let i = 0; i < tmpItems.length; i++) {
                                      tmpItems[i].id = i + 1;
                                    }
                                    this.setState({ items: tmpItems }, () => {
                                      const newTotalValue =
                                        this.calculateTotalValue(tmpItems);
                                      this.setState({
                                        totalValue: newTotalValue,
                                      });
                                    });
                                  }}
                                >
                                  <i className="fa fa-trash"></i>
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  <div className="row">
                    <div className="col-lg-4 col-sm-5 ml-auto">
                      <table className="table table-clear">
                        <tbody>
                          <tr>
                            <td className="left">
                              <strong>Total</strong>
                            </td>
                            <td className="right">
                              <strong>{this.state.totalValue + " THB"}</strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => this.setState({ isAddEventModal: false })}
            >
              Cancel
            </Button>
            <Button
              variant=""
              type="button"
              className="btn btn-primary"
              onClick={() => {
                var allEvents = this.state.bookingList.filter((obj) => {
                  return (
                    obj.start === this.state.dateTmp &&
                    obj.extendedProps.hn !== "" &&
                    obj.extendedProps.hn != null
                  );
                });

                let listHNEvent = allEvents.filter((element) => {
                  return element.extendedProps.hn === this.hnRef.current.value;
                });

                if (listHNEvent.length >= 1) {
                  swal({
                    title: `HN${this.hnRef.current.value} is already booking on this day !`,
                    text: `Please recheck booking on ${this.state.dateTmp}`,
                    icon: "warning",
                    buttons: ["Cancel", "Confirm"],
                    dangerMode: true,
                  }).then((willBooking) => {
                    if (willBooking) {
                      this.onAddEvent();
                    }
                  });
                } else {
                  this.onAddEvent();
                }
              }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

export default BookingList;
